import { User } from 'models/User';
import React, { PropsWithChildren, useCallback, useState } from 'react';
import { useApiGet, useInvalidateQuery } from 'hooks/useApi';
import { v4 as uuidv4 } from 'uuid';

const TOKEN_KEY = 'STORE-TOKEN';

type SessionContextType = {
  user?: User;
  token?: string;
  refreshToken: () => void;
};

export const SessionContext = React.createContext<SessionContextType>({
  refreshToken: () => {}
});

export default SessionContext;

const getTokenFromLocalStorage = () => {
  let token = localStorage.getItem(TOKEN_KEY);
  if (!token) {
    token = uuidv4();
    localStorage.setItem(TOKEN_KEY, token);
  }
  return token;
};

export function SessionProvider({ children }: PropsWithChildren<any>) {
  const [token, setToken] = useState(getTokenFromLocalStorage());
  const invalidate = useInvalidateQuery(['/auth/store']);
  const { data } = useApiGet('/auth/store', {
    retry: true,
    retryDelay: 1000,
    headers: {
      Authorization: token
    }
  });

  const refreshToken = useCallback(() => {
    localStorage.removeItem(TOKEN_KEY);
    setToken(getTokenFromLocalStorage());
    invalidate.invalidate();
  }, [invalidate]);

  return (
    <SessionContext.Provider
      value={{
        user: data,
        token,
        refreshToken
      }}
    >
      {children}
    </SessionContext.Provider>
  );
}
